// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  display: flex;
  font-size: 15px;
  color: rgba(47, 43, 61, 0.68);
  font-family: Public Sans;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
}
.App hr {
  margin: 0;
  color: #dbdade;
}
.App .outer-container {
  width: 100%;
}
@media screen and (max-width: 820px) {
  .App .outer-container {
    width: 67%;
  }
}
@media screen and (max-width: 600px) {
  .App .outer-container {
    width: 100%;
  }
}

.userSection {
  margin: 30px 30px 0 30px;
  display: flex;
  border: 1px solid #dbdade;
  border-radius: 5px;
  padding: 11px 30px;
  background: white;
  position: sticky;
  top: 0;
  z-index: 2;
}
.userSection .MuiAvatar-circular {
  background-color: #8f85f3;
}
.userSection .onlineIndicator {
  background-color: #28c76f;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid #fff;
  position: absolute;
  bottom: 15px;
  right: 30px;
}
.userSection .headerLastItem {
  margin-left: auto;
}

.left-navbar {
  padding: 0 20px;
}

.container {
  padding: 0 30px;
  min-height: 80vh;
}
.container .MuiFormControl-root,
.container .MuiInputBase-root {
  margin-top: 0;
}
.container .statistics .dahsboardHeader {
  color: #7367f0;
  line-height: 44px;
  font-size: 25px;
  text-align: left;
}
.container .statistics .MuiCardContent-root,
.container .statistics .MuiCardHeader-root {
  padding: 20px 20px 0 20px !important;
}
.container .statistics .MuiCardContent-root .MuiCardHeader-title,
.container .statistics .MuiCardHeader-root .MuiCardHeader-title {
  font-size: 37px;
  text-align: right;
}
.container .statistics .MuiCardContent-root .cardTitle,
.container .statistics .MuiCardHeader-root .cardTitle {
  padding: 10px;
}
.container .editHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.container .editHeader p {
  color: #7367F0;
  font-size: 25px;
}
.container .detailSection .columnOne {
  padding-bottom: 30px;
}
.container .detailSection .checkboxAlign {
  display: grid;
}
.container .detailSection .columnTwo {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  padding-bottom: 30px;
}
.container .detailSection .columnTwo .imageUploadOuter p {
  text-align: left;
}
.container .detailSection .columnTwo .imageUploadOuter .imageUploadSection {
  border: 1px solid #dbdade;
  border-radius: 5px;
  padding: 15px;
}
.container .detailSection .columnTwo .imageUploadOuter .imageUploadSection .imageDescription {
  padding: 10px 0;
}
.container .detailSection .columnTwo .additionalImage {
  margin-bottom: 29px;
}
@media screen and (max-width: 1024px) {
  .container .detailSection .columnTwo .additionalImage {
    margin-bottom: 43px;
  }
}
@media screen and (max-width: 600px) {
  .container .detailSection .columnTwo {
    display: block;
    padding-bottom: 0px;
  }
  .container .detailSection .columnTwo .imageUploadOuter {
    padding-bottom: 30px;
  }
  .container .detailSection .columnTwo .additionalImage {
    margin-bottom: 12px;
  }
}
.container .detailSection .columnThree {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  padding-bottom: 30px;
}
.container .detailSection .columnHalf {
  width: 50%;
  padding-bottom: 30px;
}
.container .detailSection .newsSubmit {
  padding-bottom: 30px;
  display: flex;
}
@media screen and (max-width: 600px) {
  .container .detailSection .newsSubmit {
    justify-content: space-between;
  }
  .container .detailSection .newsSubmit button {
    font-size: 11px;
  }
  .container .detailSection .columnOne,
  .container .detailSection .columnTwo {
    padding-bottom: 0px;
  }
}
.container .selectLabel {
  text-align: left;
  flex: 1 1;
}
.container .selectLabel:not(:last-child) {
  padding-right: 10px;
}
.container .radioSection p {
  text-align: left;
  margin: 10px 0;
}
.container .editorSection p {
  text-align: left;
  color: rgba(47, 43, 61, 0.68);
  font-family: Public Sans;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
}
.container .editorSection .wrapperClassName {
  padding: 20px;
  border: 1px solid #dbdade;
  border-radius: 5px;
}
.container .editorSection .wrapperClassName .toolbarClassName {
  margin-bottom: 0;
}
.container .editorSection .wrapperClassName .editorClassName {
  border-radius: 2px;
  border: 1px solid #F1F1F1;
  min-height: 150px;
}
.container .settings {
  padding: 20px;
}
.container .settings .settingsItems {
  display: flex;
}
.container .settings .settingsItems .settingsTitle {
  display: flex;
  width: 20%;
  margin: 8px 0 0 0;
  text-align: left;
  align-items: center;
  font-size: 16px;
}
.container .settings .settingsItems .settingsValue {
  width: 50%;
}
@media screen and (max-width: 820px) {
  .container {
    padding-left: 15px;
    padding-right: 0px;
  }
  .container .settings .settingsItems .settingsTitle {
    width: 40%;
  }
  .container .settings .settingsItems .settingsValue {
    width: 60%;
  }
}
@media screen and (max-width: 600px) {
  .container {
    padding: 0px 15px;
  }
  .container .MuiFormControl-root label {
    width: 100%;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    text-align: start;
  }
  .container .settings {
    margin-bottom: 20px;
  }
  .container .settings .settingsItems {
    display: block;
  }
  .container .settings .settingsItems .settingsTitle {
    width: 100%;
  }
  .container .settings .settingsItems .settingsValue {
    width: 100%;
  }
}

.MuiAppBar-positionSticky {
  position: sticky;
  top: 0;
  z-index: 1000;
}

.MuiTablePagination-selectLabel,
.MuiTablePagination-input {
  display: none !important;
}

.footer-section .footer-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
}
.footer-section .footer-content a {
  text-decoration: none;
  color: rgba(47, 43, 61, 0.68);
}
@media screen and (max-width: 600px) {
  .footer-section .footer-content {
    font-size: 13px;
  }
}

.userMenuItems {
  color: rgba(47, 43, 61, 0.68) !important;
  font-family: Public Sans !important;
  font-size: 15px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 15px !important;
}

.tagOuter {
  display: flex;
  margin-top: 15px;
  overflow: auto;
  padding: 10px 0;
  white-space: nowrap;
}

.profileImage {
  width: 100px;
  height: 100px;
  margin-right: 1.5rem;
  border-radius: 6px;
  object-fit: cover;
}

.noArrows .MuiInputBase-input {
  -webkit-appearance: none;
}

.noArrows .MuiInputBase-input::-webkit-inner-spin-button,
.noArrows .MuiInputBase-input::-webkit-outer-spin-button {
  appearance: none;
}

::-webkit-scrollbar {
  width: 5px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: #ffffff;
}

::-webkit-scrollbar-thumb {
  background: rgba(93, 89, 108, 0.2) !important;
  border-radius: 6px;
}

.ps__rail-y {
  z-index: 1;
}
.ps__rail-y:hover, .ps__rail-y:focus, .ps__rail-y.ps--clicking {
  background-color: #F1F0F5 !important;
}
.ps__rail-y .ps__thumb-y {
  right: 3px !important;
  left: auto !important;
  background-color: rgba(93, 89, 108, 0.2) !important;
}
.ps__rail-y .layout-vertical-nav .ps__thumb-y {
  width: 4;
}
.ps__rail-y .layout-vertical-nav:hover, .ps__rail-y .layout-vertical-nav:focus, .ps__rail-y .layout-vertical-nav.ps--clicking {
  background-color: transparent !important;
}
.ps__rail-y .layout-vertical-nav:hover .ps__thumb-y, .ps__rail-y .layout-vertical-nav:focus .ps__thumb-y, .ps__rail-y .layout-vertical-nav.ps--clicking .ps__thumb-y {
  width: 6;
}

.customTextArea {
  display: flex;
  flex-wrap: wrap;
  text-align: left;
  font-family: Public Sans;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
}
.customTextArea label {
  color: rgba(47, 43, 61, 0.68);
}
.customTextArea label:disabled {
  color: rgba(0, 0, 0, 0.38);
}
.customTextArea textarea {
  width: 100%;
  padding: 7.25px 13px;
  border-radius: 6px;
  margin-top: 8px;
  background-color: transparent !important;
  border: 1px solid rgba(47, 43, 61, 0.2);
  opacity: 1;
  color: rgba(47, 43, 61, 0.8);
  font-family: Public Sans;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
}
.customTextArea textarea:disabled {
  background-color: rgba(0, 0, 0, 0.08) !important;
  color: rgba(0, 0, 0, 0.38);
}

.tagParent {
  display: flex;
  justify-content: space-between;
}
.tagParent .tagOuter {
  max-width: 100%;
}
.tagParent .addTagMobile {
  display: block;
}
@media screen and (max-width: 0px) {
  .tagParent .addTagMobile {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACF;AACE;EACE,SAAA;EACA,cAAA;AACJ;AAEE;EACE,WAAA;AAAJ;AAGE;EACE;IACE,UAAA;EADJ;AACF;AAIE;EACE;IACE,WAAA;EAFJ;AACF;;AAMA;EACE,wBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAHF;AAKE;EACE,yBAAA;AAHJ;AAME;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAJJ;AAOE;EACE,iBAAA;AALJ;;AASA;EACE,eAAA;AANF;;AASA;EACE,eAAA;EACA,gBAAA;AANF;AAQE;;EAEE,aAAA;AANJ;AAUI;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AARN;AAWI;;EAEE,oCAAA;AATN;AAWM;;EACE,eAAA;EACA,iBAAA;AARR;AAWM;;EACE,aAAA;AARR;AAaE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAXJ;AAaI;EACE,cAAA;EACA,eAAA;AAXN;AAgBI;EACE,oBAAA;AAdN;AAiBI;EACE,aAAA;AAfN;AAkBI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,oBAAA;AAhBN;AAmBQ;EACE,gBAAA;AAjBV;AAoBQ;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;AAlBV;AAoBU;EACE,eAAA;AAlBZ;AAuBM;EACE,mBAAA;AArBR;AAwBM;EACE;IACE,mBAAA;EAtBR;AACF;AAyBM;EAhCF;IAiCI,cAAA;IACA,mBAAA;EAtBN;EAwBM;IACE,oBAAA;EAtBR;EAyBM;IACE,mBAAA;EAvBR;AACF;AA2BI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,oBAAA;AAzBN;AA4BI;EACE,UAAA;EACA,oBAAA;AA1BN;AA6BI;EACE,oBAAA;EACA,aAAA;AA3BN;AA8BI;EACE;IACE,8BAAA;EA5BN;EA8BM;IACE,eAAA;EA5BR;EAgCI;;IAEE,mBAAA;EA9BN;AACF;AAkCE;EACE,gBAAA;EACA,SAAA;AAhCJ;AAkCI;EACE,mBAAA;AAhCN;AAoCE;EACE,gBAAA;EACA,cAAA;AAlCJ;AAsCI;EACE,gBAAA;EACA,6BAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AApCN;AAuCI;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;AArCN;AAuCM;EACE,gBAAA;AArCR;AAwCM;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;AAtCR;AA2CE;EACE,aAAA;AAzCJ;AA2CI;EACE,aAAA;AAzCN;AA2CM;EACE,aAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAzCR;AA4CM;EACE,UAAA;AA1CR;AA+CE;EAlMF;IAmMI,kBAAA;IACA,kBAAA;EA5CF;EAiDM;IACE,UAAA;EA/CR;EAkDM;IACE,UAAA;EAhDR;AACF;AAqDE;EApNF;IAqNI,iBAAA;EAlDF;EAqDI;IACE,WAAA;IACA,mBAAA;IACA,iBAAA;IACA,mBAAA;IACA,iBAAA;EAnDN;EAuDE;IACE,mBAAA;EArDJ;EAuDI;IACE,cAAA;EArDN;EAuDM;IACE,WAAA;EArDR;EAwDM;IACE,WAAA;EAtDR;AACF;;AA8DA;EACE,gBAAA;EACA,MAAA;EACA,aAAA;AA3DF;;AA8DA;;EAEE,wBAAA;AA3DF;;AA8DA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AA3DF;AA6DE;EACE,qBAAA;EACA,6BAAA;AA3DJ;AA8DE;EAXF;IAYI,eAAA;EA3DF;AACF;;AA8DA;EACE,wCAAA;EACA,mCAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;AA3DF;;AA8DA;EACE,aAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AA3DF;;AA8DA;EACE,YAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;AA3DF;;AA8DA;EACE,wBAAA;AA3DF;;AA8DA;;EAGE,gBAAA;AA3DF;;AA8DA;EACE,UAAA;EACA,YAAA;AA3DF;;AA8DA;EACE,mBAAA;AA3DF;;AA8DA;EACE,6CAAA;EACA,kBAAA;AA3DF;;AA8DA;EACE,UAAA;AA3DF;AA6DE;EAGE,oCAAA;AA7DJ;AAgEE;EACE,qBAAA;EACA,qBAAA;EACA,mDAAA;AA9DJ;AAkEI;EACE,QAAA;AAhEN;AAmEI;EAGE,wCAAA;AAnEN;AAqEM;EACE,QAAA;AAnER;;AAyEA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAtEF;AAwEE;EACE,6BAAA;AAtEJ;AAwEI;EACE,0BAAA;AAtEN;AA0EE;EACE,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,uCAAA;EACA,UAAA;EACA,4BAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAxEJ;AAyEI;EACE,gDAAA;EACA,0BAAA;AAvEN;;AA4EA;EACE,aAAA;EACA,8BAAA;AAzEF;AA0EE;EACE,eAAA;AAxEJ;AA0EE;EACE,cAAA;AAxEJ;AAyEI;EAFF;IAGI,cAAA;EAtEJ;AACF","sourcesContent":[".App {\n  text-align: center;\n  display: flex;\n  font-size: 15px;\n  color: rgba(47, 43, 61, 0.68);\n  font-family: Public Sans;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 15px;\n\n  hr {\n    margin: 0;\n    color: #dbdade;\n  }\n\n  .outer-container {\n    width: 100%;\n  }\n\n  @media screen and (max-width: 820px) {\n    .outer-container {\n      width: 67%;\n    }\n  }\n\n  @media screen and (max-width: 600px) {\n    .outer-container {\n      width: 100%;\n    }\n  }\n}\n\n.userSection {\n  margin: 30px 30px 0 30px;\n  display: flex;\n  border: 1px solid #dbdade;\n  border-radius: 5px;\n  padding: 11px 30px;\n  background: white;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n\n  .MuiAvatar-circular {\n    background-color: #8f85f3;\n  }\n\n  .onlineIndicator {\n    background-color: #28c76f;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    border: 2px solid #fff;\n    position: absolute;\n    bottom: 15px;\n    right: 30px;\n  }\n\n  .headerLastItem {\n    margin-left: auto;\n  }\n}\n\n.left-navbar {\n  padding: 0 20px;\n}\n\n.container {\n  padding: 0 30px;\n  min-height: 80vh;\n\n  .MuiFormControl-root,\n  .MuiInputBase-root {\n    margin-top: 0;\n  }\n\n  .statistics {\n    .dahsboardHeader {\n      color: #7367f0;\n      line-height: 44px;\n      font-size: 25px;\n      text-align: left;\n    }\n\n    .MuiCardContent-root,\n    .MuiCardHeader-root {\n      padding: 20px 20px 0 20px !important;\n\n      .MuiCardHeader-title {\n        font-size: 37px;\n        text-align: right;\n      }\n\n      .cardTitle {\n        padding: 10px;\n      }\n    }\n  }\n\n  .editHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    p {\n      color: #7367F0;\n      font-size: 25px;\n    }\n  }\n\n  .detailSection {\n    .columnOne {\n      padding-bottom: 30px;\n    }\n\n    .checkboxAlign {\n      display: grid;\n    }\n\n    .columnTwo {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      gap: 30px;\n      padding-bottom: 30px;\n\n      .imageUploadOuter {\n        p {\n          text-align: left;\n        }\n\n        .imageUploadSection {\n          border: 1px solid #dbdade;\n          border-radius: 5px;\n          padding: 15px;\n\n          .imageDescription {\n            padding: 10px 0;\n          }\n        }\n      }\n\n      .additionalImage {\n        margin-bottom: 29px;\n      }\n\n      @media screen and (max-width: 1024px) {\n        .additionalImage {\n          margin-bottom: 43px;\n        }\n      }\n\n      @media screen and (max-width: 600px) {\n        display: block;\n        padding-bottom: 0px;\n\n        .imageUploadOuter {\n          padding-bottom: 30px;\n        }\n\n        .additionalImage {\n          margin-bottom: 12px;\n        }\n      }\n    }\n\n    .columnThree {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      gap: 30px;\n      padding-bottom: 30px;\n    }\n\n    .columnHalf {\n      width: 50%;\n      padding-bottom: 30px;\n    }\n\n    .newsSubmit {\n      padding-bottom: 30px;\n      display: flex;\n    }\n\n    @media screen and (max-width: 600px) {\n      .newsSubmit {\n        justify-content: space-between;\n\n        button {\n          font-size: 11px;\n        }\n      }\n\n      .columnOne,\n      .columnTwo {\n        padding-bottom: 0px;\n      }\n    }\n  }\n\n  .selectLabel {\n    text-align: left;\n    flex: 1;\n\n    &:not(:last-child) {\n      padding-right: 10px;\n    }\n  }\n\n  .radioSection p {\n    text-align: left;\n    margin: 10px 0;\n  }\n\n  .editorSection {\n    p {\n      text-align: left;\n      color: rgba(47, 43, 61, 0.68);\n      font-family: Public Sans;\n      font-size: 15px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 15px;\n    }\n\n    .wrapperClassName {\n      padding: 20px;\n      border: 1px solid #dbdade;\n      border-radius: 5px;\n\n      .toolbarClassName {\n        margin-bottom: 0;\n      }\n\n      .editorClassName {\n        border-radius: 2px;\n        border: 1px solid #F1F1F1;\n        min-height: 150px;\n      }\n    }\n  }\n\n  .settings {\n    padding: 20px;\n\n    .settingsItems {\n      display: flex;\n\n      .settingsTitle {\n        display: flex;\n        width: 20%;\n        margin: 8px 0 0 0;\n        text-align: left;\n        align-items: center;\n        font-size: 16px;\n      }\n\n      .settingsValue {\n        width: 50%;\n      }\n    }\n  }\n\n  @media screen and (max-width: 820px) {\n    padding-left: 15px;\n    padding-right: 0px;\n\n    .settings {\n      .settingsItems {\n\n        .settingsTitle {\n          width: 40%;\n        }\n\n        .settingsValue {\n          width: 60%;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 600px) {\n    padding: 0px 15px;\n\n    .MuiFormControl-root {\n      label {\n        width: 100%;\n        white-space: normal;\n        overflow: visible;\n        text-overflow: clip;\n        text-align: start;\n      }\n    }\n\n    .settings {\n      margin-bottom: 20px;\n\n      .settingsItems {\n        display: block;\n\n        .settingsTitle {\n          width: 100%;\n        }\n\n        .settingsValue {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n\n}\n\n.MuiAppBar-positionSticky {\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n.MuiTablePagination-selectLabel,\n.MuiTablePagination-input {\n  display: none !important;\n}\n\n.footer-section .footer-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 30px;\n\n  a {\n    text-decoration: none;\n    color: rgba(47, 43, 61, 0.68);\n  }\n\n  @media screen and (max-width: 600px) {\n    font-size: 13px;\n  }\n}\n\n.userMenuItems {\n  color: rgba(47, 43, 61, 0.68) !important;\n  font-family: Public Sans !important;\n  font-size: 15px !important;\n  font-style: normal !important;\n  font-weight: 400 !important;\n  line-height: 15px !important;\n}\n\n.tagOuter {\n  display: flex;\n  margin-top: 15px;\n  overflow: auto;\n  padding: 10px 0;\n  white-space: nowrap;\n}\n\n.profileImage {\n  width: 100px;\n  height: 100px;\n  margin-right: 1.5rem;\n  border-radius: 6px;\n  object-fit: cover;\n}\n\n.noArrows .MuiInputBase-input {\n  -webkit-appearance: none;\n}\n\n.noArrows .MuiInputBase-input::-webkit-inner-spin-button,\n.noArrows .MuiInputBase-input::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #ffffff;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(93, 89, 108, 0.2) !important;\n  border-radius: 6px;\n}\n\n.ps__rail-y {\n  z-index: 1;\n\n  &:hover,\n  &:focus,\n  &.ps--clicking {\n    background-color: #F1F0F5 !important;\n  }\n\n  .ps__thumb-y {\n    right: 3px !important;\n    left: auto !important;\n    background-color: rgba(93, 89, 108, 0.2) !important;\n  }\n\n  .layout-vertical-nav {\n    .ps__thumb-y {\n      width: 4\n    }\n\n    &:hover,\n    &:focus,\n    &.ps--clicking {\n      background-color: transparent !important;\n\n      & .ps__thumb-y {\n        width: 6\n      }\n    }\n  }\n}\n\n.customTextArea {\n  display: flex;\n  flex-wrap: wrap;\n  text-align: left;\n  font-family: Public Sans;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 15px;\n\n  label {\n    color: rgba(47, 43, 61, 0.68);\n\n    &:disabled {\n      color: rgba(0, 0, 0, 0.38);\n    }\n  }\n\n  textarea {\n    width: 100%;\n    padding: 7.25px 13px;\n    border-radius: 6px;\n    margin-top: 8px;\n    background-color: transparent !important;\n    border: 1px solid rgba(47, 43, 61, 0.2);\n    opacity: 1;\n    color: rgba(47, 43, 61, 0.80);\n    font-family: Public Sans;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 15px;\n    &:disabled {\n      background-color: rgba(0, 0, 0, 0.08) !important;\n      color: rgba(0, 0, 0, 0.38);\n    }\n  }\n}\n\n.tagParent {\n  display: flex;\n  justify-content: space-between;\n  .tagOuter {\n    max-width: 100%;\n  }\n  .addTagMobile {\n    display: block;\n    @media screen and (max-width: 0px) {\n      display: block;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
